unit BaseResultSetRequest;
{

/* Initial. */

}
interface

uses
  BaseRequest, ResultSetRequestType;

type
  TBaseResultSetRequest = class(TBaseRequest)
  private
    resultSet: TResultSetRequestType;
  public
    constructor Create(const String_LoginKey: String; const String_ResultSetKey: String; const Word_PageLength: Word; const Word_Page: Word);
  end;

implementation

constructor TBaseResultSetRequest.Create(const String_LoginKey: String; const String_ResultSetKey: String; const Word_PageLength: Word; const Word_Page: Word);
begin
  inherited Create(String_LoginKey);

  resultSet := TResultSetRequestType.Create(String_ResultSetKey, Word_PageLength, Word_Page)
end;

end.
